export default "__VITE_ASSET__DU1Q2ovz__"